import Cookies from 'js-cookie';

// Client-side mirror of TrackingConsent (app/services/tracking_consent.rb).
// Reads the `volition_consent` cookie (written by ConsentController, non-httpOnly
// so the client can read it) and reports whether a given tracking category may
// fire RIGHT NOW. This is the JS counterpart to the server-side `tracking_allowed?`
// gate: the base tag loaders are blocked server-side until consent, and these
// per-event services double-check here so that consenting to one category never
// fires another category's events.
//
// Fails closed: anything missing, malformed, stale-schema, or undecided denies.
// Keep COOKIE_NAME / VERSION in sync with TrackingConsent::COOKIE_NAME / VERSION.
const COOKIE_NAME = 'volition_consent';
const VERSION = 2;

function readConsent() {
  const raw = Cookies.get(COOKIE_NAME);
  if (!raw) { return null; }

  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (e) {
    return null;
  }
}

// True only when the visitor has made an explicit choice (`decided`) under the
// current schema version AND granted this category. Strict allowlist: only an
// exact boolean `true` grants.
export function consentAllows(category) {
  const consent = readConsent();
  if (!consent || consent.v !== VERSION || consent.decided !== true) { return false; }

  return consent.categories?.[category] === true;
}

export default { consentAllows };
